<template>
  <button class="navbar-toggler" type="button"
          data-toggle="collapse"
          :data-target="target"
          :aria-controls="target"
          :aria-expanded="toggled"
          aria-label="Toggle navigation">
    <slot>
      <svg class="navbar-toggler-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 7h16M4 12h16M4 17h16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </slot>
  </button>
</template>

<script>
export default {
  props: {
    target: {
      type: [String, Number],
      description: "Button target element"
    },
    toggled: {
      type: Boolean,
      default: false,
      description: "Whether button is toggled"
    }
  }
};
</script>

<style scoped>
.navbar-toggler {
  display: none;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  padding: 0.35rem;
  border: 1px solid rgba(24, 80, 184, 0.24);
  border-radius: 0.6rem;
  background: rgba(24, 80, 184, 0.12);
  color: #1850b8;
}

@media (max-width: 767.98px) {
  .navbar-toggler {
    display: inline-flex;
  }
}

.navbar-toggler:focus {
  outline: none;
  box-shadow: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.05rem;
  height: 1.05rem;
  color: inherit;
}
</style>
